const REQUESTED_STAGING_HOST = 'staging.heytasky.com'
const CLERK_COMPATIBLE_STAGING_HOST = 'staging.app.heytasky.com'

export function stagingRedirectUrl(url: URL) {
  if (url.hostname !== REQUESTED_STAGING_HOST) return null

  const destination = new URL(url.href)
  destination.hostname = CLERK_COMPATIBLE_STAGING_HOST
  return destination.toString()
}

const LIVE_AUTH_HOSTS = new Set([
  'app.heytasky.com',
  REQUESTED_STAGING_HOST,
  CLERK_COMPATIBLE_STAGING_HOST,
])

export function clerkConfigurationError(url: URL, publishableKey: string | undefined) {
  if (!LIVE_AUTH_HOSTS.has(url.hostname)) return null
  if (publishableKey?.startsWith('pk_live_')) return null
  return 'This deployment is not configured for Hey Tasky production authentication.'
}
